<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <h2 mat-dialog-title>{{ title }}</h2>
    <mat-icon>drag_indicator</mat-icon>
</div>
<mat-dialog-content class="dialog-content">
    <div class="footer-tools">
        <app-bulk-user-chooser  [formControl]="userFilter"
        label="Names or Hawk Ids (press enter after each)" [selectedUsers]="selectedUsers"
        (usersChange)="usersChange($event)"></app-bulk-user-chooser>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    
    <!-- <button mat-button (click)="cancel()" *ngIf="!data?.isNew">Done</button> -->
    <button mat-button (click)="cancel()">Cancel</button>
    <!-- <button mat-button color="primary" (click)="createGroup()" *ngIf="data?.isNew">Create</button> -->
    <button mat-flat-button [disabled]="! userFilter.value?.length" (click)="addMembers()"><mat-icon>add</mat-icon> Add selected user(s)</button>
</mat-dialog-actions>